module.exports = __webpack_public_path__ + "static/illust01-dcf9243c9c41b397953ad8cb81f0e731.webp";